import { render, staticRenderFns } from "./ConfiguracaoIncisosCadastro.vue?vue&type=template&id=1c5e55b6&scoped=true"
import script from "./ConfiguracaoIncisosCadastro.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoIncisosCadastro.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoIncisosCadastro.vue?vue&type=style&index=0&id=1c5e55b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e55b6",
  null
  
)

export default component.exports